import { Filter } from '@cubejs-client/core';

import { DimPurchaseOrderField } from '~/common/types/cubes/DimPuchaseOrder';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { PurchaseOrderVolumeWidget } from './PurchaseOrderVolumeWidget';

export const SupplierPurchaseOrderVolumeWidget = () => {
  const { entityId } = useModuleContext();
  const filters: Filter[] = [
    {
      member: DimPurchaseOrderField.SUPPLIER_ID,
      operator: 'equals',
      values: [entityId],
    },
  ];
  return <PurchaseOrderVolumeWidget filters={filters} />;
};
